import { render, staticRenderFns } from "./consultationform.vue?vue&type=template&id=84eeaffa&scoped=true&"
import script from "./consultationform.vue?vue&type=script&lang=js&"
export * from "./consultationform.vue?vue&type=script&lang=js&"
import style0 from "./consultationform.vue?vue&type=style&index=0&id=84eeaffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eeaffa",
  null
  
)

export default component.exports